import React, { useState, useEffect } from 'react';
import { ServerErrorMessage } from '../../../../shared/utils/error';
import ValidacionPartesScreen from './screen';
import { PartesAdapter, Parte, FiltroPartes } from '../../../../infraestructure/persistence/rest/PartesAdapter';
import { useNotifications } from '../../../../shared/hooks/Notifications';
//import { downloadFile } from '../../../../shared/utils/download';

const PartesContainer = (props:any) => {
	const {location}=props;
	const api = new PartesAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ partes, setPartes ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState(false)
	let result: any;

	useEffect(() => setIsLoading(false), [ partes ]);

	const getPartes = async (filtro: FiltroPartes ) => {
		setIsLoading(true)
		try {
			result = (filtro.filterDrillDown === '') ? await api.ListarPartesValidacion(filtro) : await api.ListarPartesDrillDown(filtro);
			if(result.data && result.data!=="")
			{
				setPartes([ ...result.data ]);
			}else{resultError();setIsLoading(false);}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception);
			setIsLoading(false);
		}
	};

	// const updateParte = async (parte: Parte) => {
	// 	try {
	// 		result = await api.ModificarParte(parte);
	// 		if(result.data && result.data!=="")
	// 		{
	// 			let pos = partes.findIndex((f: Parte) => f.idParte === parte.idParte);
	// 			let newData = [ ...partes ];
	// 			newData[pos] = result.data[0];
	// 			setPartes([ ...newData ] || []);
	// 			launchNotification({type:"success",title:"Modificación",message:"Se ha modificado un parte."})
	// 		}else{resultError()}
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)
	// 	}
	// };

	const validateAction = async (validatePartes: any, tipo:string) => {
		let sinAdjuntos = validatePartes.filter((p:Parte)=> !p.tieneAdjuntos).length >0;
		if(sinAdjuntos)
			launchNotification({type:"warning",title:"Validación",message:"No se permite validar partes sin adjuntos."})
		else{
			setIsLoading(true)
			let ids = validatePartes.map((p:Parte) => p.idParte);
			try {
				result = await api.ValidarPartes(ids, tipo);
				if(result.data && result.data!=="")
				{
					let pos=0;
					let newData:any=[...partes ];
			
					ids.forEach((i:number)=>{
						pos = newData.findIndex((f: Parte) => f.idParte === i);
						newData.splice(pos, 1);
					});
					setPartes([ ...newData ]);
					launchNotification({type:"success",title:"Validación",message:"Partes validados con éxito."})
				}else{resultError();setIsLoading(false)}
			} catch (error) {
				let exception = ServerErrorMessage(error);
				exceptionError(exception)
				setIsLoading(false)
			}
		}
		
	}

	const desvalidarAction = async (Idspartes: any, tipo:string) => {
		const hayFacturados = Idspartes.filter((p:Parte) => p.facturado===true).length>0;
		const hayAbonados = Idspartes.filter((p:Parte) => p.abono===true).length>0;
		if(hayFacturados===true)
			{launchNotification({type:"warning",title:"Desvalidación",message:"No se pueden desvalidar partes facturados."})}
		else
		{
			if(hayAbonados===true)
				{launchNotification({type:"warning",title:"Desvalidación",message:"No se pueden desvalidar partes abonados."})}
			else
			{
				setIsLoading(true)
				let ids = Idspartes.map((p:Parte) => p.idParte);
				try {
					result = await api.DesvalidarPartes(ids, tipo);
					if(result.data && result.data!=="")
					{
						let pos=0;
						let newData:any=[...partes ];
				
						ids.forEach((i:number)=>{
							pos = newData.findIndex((f: Parte) => f.idParte === i);
							newData.splice(pos, 1);
						});
						setPartes([ ...newData ]);
						launchNotification({type:"success",title:"Desvalidación",message:"Partes desvalidados con éxito."})
					}else{resultError();setIsLoading(false)}
				} catch (error) {
					let exception = ServerErrorMessage(error);
					exceptionError(exception)
					setIsLoading(false)
				}
			}
		}
	}

	// const DownloadDataUsers = async (IdsPartes: any ) => {
	// 	try {
	// 		result = await api.DescargarDatosUsuarios(IdsPartes);
	// 		if(result.data && result.data!=="")
	// 		{
	// 			downloadFile(result.data,'Funciones_SubFunciones.xlsx');
	// 		}else{resultError()}
	// 	} catch (error) {
	// 		let exception = ServerErrorMessage(error);
	// 		exceptionError(exception)
	// 	}
	// };

	// const adjuntar = (selected:any) =>{
	// 	let newData:any = [...partes];
    
    // selected.forEach((parte:Parte)=>{
    //   let changes = {tieneAdjuntos:true}
    //   let pos = partes.findIndex((f: Parte) => f.idParte === parte.idParte);
    //   newData[pos] = {...newData[pos],...changes};
	// 	})
		
	// 	setPartes([ ...newData ]);
	// }

	return (
		<ValidacionPartesScreen
			data={partes}
			//handleUpdate={updateParte}
			handleFilter={getPartes}
			handleValidar={validateAction}
			handleDesvalidar={desvalidarAction}
			//handleAdjuntar={adjuntar}
			//handleDownLoad={DownloadDataUsers}
			isLoading={isLoading}
			location={location}
		/>
	);
};

export default PartesContainer;
